var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAviationServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.999,
    height: 71.999,
    viewBox: "0 0 71.999 71.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    width: 71.999,
    height: 71.999,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    d: "M36,0A36,36,0,1,0,72,36,36.04,36.04,0,0,0,36,0m0,67.436a31.279,31.279,0,0,1-19.773-7.022L25.2,56.53,20.453,45.568,8.292,50.832A31.43,31.43,0,1,1,36,67.436",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    d: "M58.331,39.941l-10.839,4.4L29.111,39.028,25.66,40.305l12.367,8.358-8.081,3.81L23.4,50.312l-3.571,1.5L30.3,59.15,62.26,45.373c2.079-.77,4.067-3.343,3.791-4.418-.49-1-4.2-2.449-7.72-1.014",
    transform: "translate(-8.519 -16.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    d: "M62.064,82.2l-7.586,2.323A4.174,4.174,0,0,1,54.3,85.8l-.09.249-6.755-2.042.161-.533,6.231,1.884c.18-.792.418-3.2-2.872-4.48-1.531-.533-4.091-1.427-5.229-1.848a4.58,4.58,0,0,0-3.071-.282l-4.227,1.83L42.136,89.1l1.649-.714a1.575,1.575,0,0,1,1.078-.064l7.037,2.1a1.575,1.575,0,0,0,1.091-.07L67.149,84.06c-1.323-3.049-5.085-1.865-5.085-1.865",
    transform: "translate(-16.514 -33.768)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationServices);
export default __webpack_public_path__ + "static/media/aviation-services.791d849b5b5a962a9e4c72555360fbc9.svg";
export { ForwardRef as ReactComponent };